import DemoWrapper from "../../utils/DemoPageWrapper";
/* eslint-disable import/no-webpack-loader-syntax */
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "value",
      description: "绑定值",
      type: "String / Number / Array"
    },
    {
      prop: "type",
      description: "类型",
      type: "String",
      available:
        "date、time、datetime、singleDatetime、week、month、quarter、halfYear、year",
      default: "date"
    },
    {
      prop: "size",
      description: "尺寸大小",
      type: "String",
      available: "large、middle、default、small、mini",
      default: "default"
    },
    {
      prop: "format",
      description: "展示格式，可为moment.js字符，也支持函数，参数为时间戳",
      type: "String / Function"
    },
    {
      prop: "valueFormat",
      description: "值格式，可用timestamp获取时间戳",
      type: "String"
    },
    {
      prop: "range",
      description: "是否范围选择",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "rangeSeparator",
      description: "范围选择分隔符",
      type: "String",
      default: "-"
    },
    {
      prop: "multiple",
      description: "是否多选",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "multipleSeparator",
      description: "多选分隔符",
      type: "String",
      default: ";"
    },
    {
      prop: "clearable",
      description: "是否可清除",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "shortcut",
      description: "是否显示快捷方式",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "shortcutOptions",
      description:
        "快捷方式自定义列表, 格式为[{ text: '显示文本', onClick: '点击触发函数，返回值需为时间戳，范围选择返回数组时间戳' }]",
      type: "Array"
    },
    {
      prop: "precision",
      description: "时刻精度",
      type: "String",
      available: "second、minute、hour",
      default: "second"
    },
    {
      prop: "firstDayOfWeek",
      description: "周开始日，默认周日开始",
      type: "Number",
      default: "0"
    },
    {
      prop: "defaultTime",
      description: "默认时刻，格式需为HH:mm:ss；范围选择时可分别指定前后默认值",
      type: "Array",
      default: "['00:00:00']"
    },
    {
      prop: "disabled",
      description: "disabled",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "border",
      description: "是否有边框",
      type: "Boolean",
      default: "true"
    },
    {
      prop: "padding",
      description: "input内边距",
      type: "Number",
      default: "10"
    },
    {
      prop: "placeholder",
      description: "placeholder",
      type: "String",
      default: "请选择"
    },
    {
      prop: "appendToBody",
      description: "同Dropdown",
      type: "Boolean"
    },
    {
      prop: "boundariesSelector",
      description: "同Dropdown",
      type: "String"
    },
    {
      prop: "enableInputChecker",
      description: "开启点击年、月label展示input和下拉框",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "validator",
      description: "前置校验器",
      type: "Function"
    }
  ],
  events: [
    {
      name: "change",
      description: "值改变事件",
      argument: "value"
    }
  ],
  methods: [],
  slots: []
};

export default DemoWrapper(Demo, DemoSource, config);
